import React from 'react';
import PropTypes from 'prop-types';
import { showNotification } from '../../../common/helpers/notifications';
import { Button } from '../../../../modules/infra/ui/button/button';
import CopyIcon from '../../../../modules/admin/shops/import/external-platforms-import/icons/copy.svg';

const WalkInListUrlDisplay = ({ url }) => {
  const copyTextToClipboard = (text) => {
    if (text) {
      try {
        navigator.clipboard.writeText(text);
        showNotification({
          title: 'Copied',
          message: 'Walk-in list URL copied to clipboard.',
          autoDismiss: 5,
        });
      } catch (e) {
        showNotification({
          title: 'Failed to copy',
          message: 'Failed to copy URL to clipboard. Please copy manually.',
          autoDismiss: 5,
        });
      }
    }
  };

  const handleCopyClick = () => {
    copyTextToClipboard(url);
  };

  if (!url) return null;

  return (
    <div style={{ display: 'flex', alignItems: 'center', gap: 8, marginTop: 8 }}>
      <input
        type="text"
        value={url}
        disabled
        style={{ flex: 1, padding: '8px', borderRadius: 4, border: '1px solid #ccc', background: '#f9f9f9', fontSize: 14 }}
        readOnly
      />
      <Button.Text
        type="button"
        onClick={handleCopyClick}
        style={{
          border: '1px solid #ccc',
          borderRadius: 4,
          background: '#fff',
          padding: 6,
          cursor: 'pointer',
          display: 'flex',
          alignItems: 'center',
          transition: 'background 0.2s',
        }}
        onMouseOver={e => (e.currentTarget.style.background = '#f0f0f0')}
        onMouseOut={e => (e.currentTarget.style.background = '#fff')}
        aria-label="Copy walk-in list URL"
      >
        <CopyIcon width={18} height={18} style={{ display: 'block' }} />
      </Button.Text>
    </div>
  );
};

WalkInListUrlDisplay.propTypes = {
  url: PropTypes.string,
};

export default WalkInListUrlDisplay;
